module.exports = __webpack_public_path__ + "img/flot2.82932545.svg";